// extracted by mini-css-extract-plugin
module.exports = {"ocean-pro-home-solar-battery":"OceanSmartMeterBackupSwitch_ocean-pro-home-solar-battery__eKx4o","FAQ":"OceanSmartMeterBackupSwitch_FAQ__HPAMS"};